import $ from 'jquery';
import {
  handleDownloadAction,
  handleDownloadSelection,
  handleExportToAttachment,
  handleExportToShare,
} from '~core/actions';
import { downloadGridPdf, previewGridPdf } from '~core/grigliaProvino';
import { modifyState } from '~src/state';
import { addPagesToExportMenu } from './addPagesToExportMenu';
import { addProvinoFormatsToExportMenu } from './addProvinoFormatsToExportMenu';

const defaultDownloadFileTypeId = 'PNG';

const data = [
  {
    id: 'PNG',
    text: 'PNG',
  },
  {
    id: 'JPEG',
    text: 'JPEG',
  },
  {
    id: 'PDF',
    text: 'PDF',
  },
  {
    id: 'SVG',
    text: 'SVG',
  },
];

const initSubmenuExportClickListener = () => {
  $('body').on('click', '[data-giotto-action="export"]', handleDownloadAction);
  $('body').on(
    'click',
    '[data-giotto-action="download-selection"]',
    handleDownloadSelection
  );
  $('body').on(
    'click',
    '[data-giotto-action="export-to-attachment"]',
    handleExportToAttachment
  );

  if (navigator.share) {
    $('body').on(
      'click',
      '[data-giotto-action="export-to-share"]',
      handleExportToShare
    );
  } else {
    $('#export-to-share').hide();
  }

  $('body').on(
    'click',
    '[data-navbar-submenu-toggle-target="export"]',
    previewGridPdf
  );

  $('body').on(
    'click',
    '[data-giotto-action="export-provino"]',
    downloadGridPdf
  );
  $('body').on(
    'change',
    '#outer-provino-grid-padding, #inner-provino-grid-padding, #navbar-submenu-export-provino-output, #navbar-submenu-export-select-pages',
    previewGridPdf
  );
};

const onChangeDownloadType = (event) => {
  const selected = event.params.data;
  if (!selected) {
    return;
  }
  modifyState('submenu.export.downloadFileType', selected.id);
};

export const initSubmenuExportTypeChangeListeners = (
  extraData = [],
  overrideDefaultDownloadFileTypeId
) => {
  $('#navbar-submenu-export-filetype').select2({
    data: [...extraData, ...data],
    tags: false,
    width: '100%',
    theme: 'bootstrap4',
    placeholder: 'Seleziona uno formato',
  });

  $('body').off('select2:select', '#navbar-submenu-export-filetype');
  $('body').on(
    'select2:select',
    '#navbar-submenu-export-filetype',
    onChangeDownloadType
  );

  modifyState(
    'submenu.export.downloadFileType',
    overrideDefaultDownloadFileTypeId ?? defaultDownloadFileTypeId
  );

  $('#navbar-submenu-export-filetype').trigger({
    type: 'select2:select',
    params: {
      data: extraData[0],
    },
  });
};

export const initSubmenuExport = () => {
  initSubmenuExportClickListener();
  initSubmenuExportTypeChangeListeners();
  addPagesToExportMenu();
  addProvinoFormatsToExportMenu();
};
